export const ExitType = {
    Default: 'default',
    Quote: 'quote',
    Base: 'base',
};
export const StrategyType = {
    Arithmetic: 'arithmetic',
    ArithmeticLP: 'trailing_arithmetic_lp',
    Geometric: 'geometric',
};
